import React from "react";
import { Mail, Phone, Linkedin } from "lucide-react";
import { directors, EMAIL, PHONE_RAW } from "../mock";

export default function Directors() {
  return (
    <section id="directors" className="py-16 lg:py-24 bg-gradient-to-b from-green-50/40 to-transparent">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-green-100/70 text-[#5a9b3a] text-xs font-semibold tracking-[0.2em] uppercase">
            Our Directors
          </div>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl md:text-5xl text-[#122b45] leading-tight">
            The hearts &amp; minds behind <span className="text-[#7cb342]">Nanhe Kadam.</span>
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-8">
          {directors.map((d, i) => (
            <div key={d.name} className={`bg-white rounded-3xl overflow-hidden shadow-[0_18px_40px_-25px_rgba(18,43,69,0.25)] border border-orange-100/50 ${i === 0 ? "reveal-left" : "reveal-right"}`}>
              <div className="aspect-[4/3] overflow-hidden">
                <img src={d.img} alt={d.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6 md:p-8">
                <div className="text-xs uppercase tracking-[0.2em] text-[#ee6c4d] font-semibold">{d.role}</div>
                <h3 className="mt-2 font-serif text-2xl text-[#122b45]">{d.name}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{d.bio}</p>
                <div className="mt-4 flex items-center gap-2 text-sm text-[#122b45]">
                  <Phone className="w-4 h-4 text-[#ee6c4d]" />
                  <a href={`tel:${d.phoneRaw || PHONE_RAW}`} className="font-medium hover:text-[#ee6c4d] transition">
                    {d.phone || "+91 88046 91673"}
                  </a>
                </div>
                <div className="mt-5 flex flex-wrap gap-3">
                  <a href={`mailto:${d.email || EMAIL}`} className="flex items-center gap-2 px-3.5 py-2 rounded-full border border-slate-200 text-sm text-[#122b45] hover:border-[#ee6c4d] hover:text-[#ee6c4d] transition">
                    <Mail className="w-4 h-4" /> Email
                  </a>
                  <a href={`tel:${d.phoneRaw || PHONE_RAW}`} className="flex items-center gap-2 px-3.5 py-2 rounded-full border border-slate-200 text-sm text-[#122b45] hover:border-[#ee6c4d] hover:text-[#ee6c4d] transition">
                    <Phone className="w-4 h-4" /> Call
                  </a>
                  <a href="#" className="flex items-center gap-2 px-3.5 py-2 rounded-full border border-slate-200 text-sm text-[#122b45] hover:border-[#ee6c4d] hover:text-[#ee6c4d] transition">
                    <Linkedin className="w-4 h-4" /> LinkedIn
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
